__webpack_require__.p = "https://fantasy.dpworldtour.com/";